import { atom } from 'recoil';

const searchQuery = atom({
  key: 'searchQuery',
  default: '',
});

export default searchQuery;
